import React, { useEffect, useMemo } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useCreateBriefWithSlugMutation } from '@99designs/apps/spa/pages/create/mutations/CreateBriefWithSlug/CreateBriefWithSlug.generated';
import { parseQueryString } from '@99designs/apps/spa/pages/create/util/queryString';
import { Loading } from '@99designs/spa-common';
import { linkTo } from '@99designs/routing';

type Params = {
    slug: string;
};

export function CreateBriefWithSlug() {
    const { slug } = useParams<Params>() as Params;
    const { search } = useLocation();
    const { designerId, category, platform } = parseQueryString(search);

    const [CreateBriefWithSlug, { error, data }] = useCreateBriefWithSlugMutation();

    // Pass through some special-case fields used by a small number of briefs.
    const fields = useMemo(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const fields: Record<string, any> = {};
        if (category) {
            fields.category = category;
        }

        // Backend expects an uppercase (web-builder) platform passed through.
        if (platform) {
            fields.platform = platform.toUpperCase();
        }
        return fields;
    }, [category, platform]);

    useEffect(() => {
        const designerIds = designerId ? [designerId] : [];
        CreateBriefWithSlug({
            variables: { slug, designerIds, fields },
        });
    }, [CreateBriefWithSlug, designerId, slug, fields]);

    if (error) {
        throw error;
    }

    if (data) {
        return <Navigate replace to={{ pathname: linkTo.brief(data.brief.id, 1), search }} />;
    }

    return <Loading />;
}
